import ContractFilterStore from "./store/contractFilterStore";
import ContractsFilter from "./components/ContractsFilter";
import ContractPaging from "./components/ContractPaging";

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }
    options.store.registerModule('contractsFilterPlugin', ContractFilterStore);

    Vue.component('ContractsFilter', ContractsFilter);
    Vue.component('ContractPaging', ContractPaging);
  },
};
